"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.intents = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Check = _interopRequireDefault(require("@decisiv/iconix/lib/components/Check"));

var _CheckCircleF = _interopRequireDefault(require("@decisiv/iconix/lib/components/CheckCircleF"));

var _Exclamation = _interopRequireDefault(require("@decisiv/iconix/lib/components/Exclamation"));

var _ExclamationCircleF = _interopRequireDefault(require("@decisiv/iconix/lib/components/ExclamationCircleF"));

var _ExclamationTriangle = _interopRequireDefault(require("@decisiv/iconix/lib/components/ExclamationTriangle"));

var _ExclamationTriangleF = _interopRequireDefault(require("@decisiv/iconix/lib/components/ExclamationTriangleF"));

var _Info = _interopRequireDefault(require("@decisiv/iconix/lib/components/Info"));

var _InfoCircleF = _interopRequireDefault(require("@decisiv/iconix/lib/components/InfoCircleF"));

var _Question = _interopRequireDefault(require("@decisiv/iconix/lib/components/Question"));

var _QuestionCircleF = _interopRequireDefault(require("@decisiv/iconix/lib/components/QuestionCircleF"));

var _styledComponentsModifiers = require("styled-components-modifiers");

var _designTokens = require("@decisiv/design-tokens");

var _commonUIColors = require("../../utils/commonUIColors");

var _Typography = require("../Typography");

var _styleModifiers = require("../../utils/styleModifiers");

var _schema = _interopRequireDefault(require("./schema"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconContainer = _styledComponents.default.div.withConfig({
  displayName: "Message__IconContainer",
  componentId: "tou7nb-0"
})(["line-height:0;margin-right:", ";border-radius:50%;display:flex;justify-content:center;align-items:center;background-color:", ";flex-shrink:0;"], (0, _rem.default)(5), function (_ref) {
  var colorProp = _ref.color;
  return colorProp;
});

var sizeStyles = (0, _styledComponentsModifiers.applyStyleModifiers)({
  small: function small() {
    return "\n      ".concat(IconContainer, " {\n        background-color: transparent\n      }\n    ");
  },
  medium: function medium(_ref2) {
    var variant = _ref2.variant;
    return "\n      ".concat(variant === 'vertical' ? "max-width: 240px;" : '', "\n\n      ").concat(IconContainer, " {\n        margin-right: 10px;\n        width: 36px;\n        height: 36px;\n      }\n    ");
  },
  large: function large() {
    return "\n      max-width: 340px;\n      ".concat(IconContainer, " {\n        width: 60px;\n        height: 60px;\n      }\n    ");
  },
  extraLarge: function extraLarge() {
    return "\n      max-width: 480px;\n      ".concat(IconContainer, " {\n        width: 60px;\n        height: 60px;\n      }\n    ");
  }
}, 'size');

var Container = _styledComponents.default.div.withConfig({
  displayName: "Message__Container",
  componentId: "tou7nb-1"
})(["display:flex;align-items:flex-start;line-height:1.4;text-align:left;", " ", ";", "{margin-top:10px;}", ",", "{margin-top:20px;}"], sizeStyles, (0, _styleModifiers.when)('isVertical', (0, _styledComponents.css)(["flex-direction:column;align-items:center;text-align:center;", "{margin-right:0;}", "{margin-top:5px;}"], IconContainer, _Typography.P)), _Typography.H4, _Typography.H3, _Typography.H2);

var information = _commonUIColors.commonUIColors.information,
    success = _commonUIColors.commonUIColors.success,
    warning = _commonUIColors.commonUIColors.warning,
    danger = _commonUIColors.commonUIColors.danger,
    licoriceMousse = _commonUIColors.commonUIColors.licoriceMousse; // exported for testing purposes

var intents = {
  information: {
    color: information,
    icon: {
      normal: _Info.default,
      filled: _InfoCircleF.default
    }
  },
  success: {
    color: success,
    icon: {
      normal: _Check.default,
      filled: _CheckCircleF.default
    }
  },
  warning: {
    color: warning,
    icon: {
      normal: _Exclamation.default,
      filled: _ExclamationCircleF.default
    }
  },
  danger: {
    color: danger,
    icon: {
      normal: _ExclamationTriangle.default,
      filled: _ExclamationTriangleF.default
    }
  },
  help: {
    color: licoriceMousse,
    icon: {
      normal: _Question.default,
      filled: _QuestionCircleF.default
    }
  }
};
exports.intents = intents;

function getIconSize(messageSize) {
  switch (messageSize) {
    case 'small':
    case 'medium':
      return 'medium';

    case 'large':
    case 'extraLarge':
      return 'large';

    default:
      return 'medium';
  }
}

var Message = function Message(props, ref) {
  /* istanbul ignore next intent default value */
  var _props$intent = props.intent,
      intent = _props$intent === void 0 ? 'information' : _props$intent,
      colorProp = props.color,
      icon = props.icon,
      children = props.children,
      title = props.title,
      rest = _objectWithoutProperties(props, ["intent", "color", "icon", "children", "title"]);

  var _rest$size = rest.size,
      size = _rest$size === void 0 ? 'small' : _rest$size,
      _rest$variant = rest.variant,
      variant = _rest$variant === void 0 ? 'horizontal' : _rest$variant;
  var isVertical = size === 'medium' && variant === 'vertical' || size === 'large' || size === 'extraLarge';
  var intentValues = intents[intent] || intents.information;
  var finalColor = colorProp ? _commonUIColors.commonUIColors[colorProp] || intentValues.color : intentValues.color;
  var IconComponent = (0, _react.useMemo)(function () {
    var Icon = icon || (size === 'small' ? intentValues.icon.filled : intentValues.icon.normal);
    return _react.default.createElement(IconContainer, {
      color: (0, _toColorString.default)(finalColor),
      "aria-hidden": true
    }, _react.default.createElement(Icon, {
      size: getIconSize(size),
      color: size === 'small' ? (0, _toColorString.default)(finalColor) : (0, _toColorString.default)(_designTokens.color.base.snowWhite)
    }));
  }, [finalColor, icon, intentValues.icon, size]);
  var TitleComponent = (0, _react.useMemo)(function () {
    switch (size) {
      case 'small':
        return _Typography.P;

      case 'medium':
        if (variant === 'vertical') return _Typography.H4;
        return _Typography.P;

      case 'large':
        return _Typography.H3;

      case 'extraLarge':
        return _Typography.H2;

      default:
        return _Typography.P;
    }
  }, [variant, size]);
  return _react.default.createElement(Container, _extends({
    isVertical: isVertical
  }, rest, {
    ref: ref
  }), IconComponent, _react.default.createElement("div", null, size !== 'small' && title && _react.default.createElement(TitleComponent, {
    color: "charcoal"
  }, title), _react.default.createElement(_Typography.P, {
    color: "alaskanHusky",
    size: size === 'small' || size === 'medium' ? 'small' : undefined
  }, children)));
};

var MessageWithRef = (0, _react.forwardRef)(Message); // @ts-ignore

MessageWithRef.propTypes = _objectSpread({}, _schema.default.propTypes, {
  color: _propTypes.default.oneOf(Object.keys(_commonUIColors.commonUIColors)),
  icon: _propTypes.default.elementType,
  intent: _propTypes.default.oneOf(Object.keys(intents))
});
MessageWithRef.defaultProps = {
  intent: 'information',
  size: 'small'
};
MessageWithRef.displayName = 'Message';
var _default = MessageWithRef;
exports.default = _default;